const Events = [

    { 'name': 'xyz', 
      'text': '', 
      'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841283/aces/events/20191003_125758_bvwgwc.jpg' 
    },
    
    { 'name': 'xyz', 
      'text': '', 
      'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841275/aces/events/20191003_104516_lqweby.jpg'
    },
   
    { 'name': 'xyz', 
      'text': '', 
       'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841272/aces/events/20191003_125435_ggob9m.jpg' 
    },
    
    { 'name': 'xyz', 
      'text': '', 
      'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841267/aces/events/IMG_0040_zvm3te.jpg' 
    },
    { 'name': 'xyz', 
      'text': '', 
      'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841263/aces/events/IMG_20191003_113836_g8mwaf.jpg' 
    },
    
    { 'name': 'xyz', 
      'text': '', 
      'url': 'https://res.cloudinary.com/dcgtilnwq/video/upload/v1640841261/aces/events/aces_it_nu-20211229-0001_heerks.mp4',"isVideo":true 
    },
    
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/video/upload/v1640841395/aces/events/Snapchat-487896050_uajukk.mp4',"isVideo":true },
  
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841259/aces/events/IMG_0037_x4mihw.jpg' },
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841259/aces/events/IMG_0042_uahuct.jpg' },
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841249/aces/events/IMG-20191003-WA0018_cxkkwy.jpg' },
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841248/aces/events/IMG-20191003-WA0019_x6lqso.jpg' },
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841246/aces/events/The_Road_Ahead_Final_hvshy0.png' },
    { 'name': 'xyz', 'text': '', 'url': 'https://res.cloudinary.com/dcgtilnwq/image/upload/v1640841237/aces/events/IMG_20180201_172722_oqtqq1.jpg' }
]

export default Events;